import * as React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'
import { Link } from 'react-router'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'

export const ServiceInfo = ({ service }) => (
  <div className={sMarg.mb30}>
    <div className={sText.lineTitle}>Service Info</div>
    <SimpleTable>
      <div>
        <div>Number:</div>
        <div>
          <Link to={`/dashboard/numbers/${service.id}`}>{service.number}</Link>
        </div>
      </div>
      <div>
        <div>Billing Account:</div>
        <div>
          <Link to={`/dashboard/billing/accounts/${service.ban}`}>{service.ban}</Link>
        </div>
      </div>
    </SimpleTable>
  </div>
)



// WEBPACK FOOTER //
// src/pages/MessageThread/ServiceInfo.tsx